import { render, staticRenderFns } from "./hotelService.vue?vue&type=template&id=568de64c&scoped=true"
import script from "./hotelService.vue?vue&type=script&lang=js"
export * from "./hotelService.vue?vue&type=script&lang=js"
import style0 from "./hotelService.vue?vue&type=style&index=0&id=568de64c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568de64c",
  null
  
)

export default component.exports